import MaterialUIBadge from '@material-ui/core/Badge'
import { withStyles } from '@material-ui/core/styles'

const Badge = withStyles({
  badge: {
    fontSize: 10,
    minWidth: 14,
    height: 14,
    padding: '0 2px'
  }
})(MaterialUIBadge)

export default Badge
